import React, { useEffect, useState } from "react";

import diamondDummy from "../assets/diamonds/diamond_round.png";

const Image = ({ url, alt = "Image" }) => {
  const [imgSrc, setImgSrc] = useState("");
  const [isVideo, setIsVideo] = useState(false);

  useEffect(() => {
    if (url) {
      const isVideoURL =
        url.endsWith(".html") ||
        url.includes("/VIDEO/") ||
        url.includes("nivoda-inhousemedia");
      if (isVideoURL) {
        setIsVideo(url);
      }
      setImgSrc(isVideoURL ? diamondDummy : url);
    }
  }, [url]);

  return (
    <>
      {isVideo ? (
        <iframe src={isVideo} loading="lazy" />
      ) : (
        <img
          src={imgSrc || diamondDummy}
          alt={alt}
          onError={() => setImgSrc(diamondDummy)}
        />
      )}
    </>
  );
};

export default Image;
